import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { SHARED_MODULES } from '../../../shared.';
import { PhTooltipDirective } from '../../directives/ph-tooltip.directive';
import { HotkeyTooltipComponent } from '../hotkey-tooltip/hotkey-tooltip.component';
import { PhIconWrapperComponent } from '../ph-icon-wrapper/ph-icon-wrapper.component';

@Component({
    selector: 'ph-selected-panel',
    templateUrl: './selected-panel.component.html',
    styleUrls: ['./selected-panel.component.scss'],
    encapsulation: ViewEncapsulation.None,
	imports: [SHARED_MODULES, PhTooltipDirective, HotkeyTooltipComponent, PhIconWrapperComponent],
    standalone: true
})
export class SelectedPanelComponent {

	@Input() offsetLeft: number = 8;
	@Input() offsetTop: number = 8;
	@Input() selectedQuantity: number = 0;
	@Input() hideSelectedLabel: boolean = false;

	@Output() close: EventEmitter<void> = new EventEmitter<void>();

	constructor() {}
}
